export default "__VITE_ASSET__DMi$iyng__"